<template>
    <div class="hero__content">
        <div class="hero_img_container">
            <img class="hero__deco" :src="home_hero_desktop_image"
                 alt="Offerta Speciale per i nuovi soci ; Diventa socio Altroconsumo 2€ per 2 mesi ; Compila il form e scegli un Regalo di Benvenuto ; Puoi scegliere tra questi e tantissimi altri premi! ; Philips - MONT BLANC - Calvin Klein - BOSCH - Moulinex - Polaroid - JBL - HUAWEI - D&G - Moschino - Sony - Hugo BOSS">
        </div>
        <div class="purple-circle-container">
            <div class="purple-circle">
                <div class="deux-euro">
                    <span>€</span>
                    <h4>2 </h4>
                </div>
                <p class="nl-text"  >2 maanden</p>
            </div>
        </div>
        <div class="orange-circle-container">
            <div class="orange-circle">
                <p>Proef- <br> periode</p>
            </div>
        </div>
    </div>
</template>

<script>
import image_mixin from "../mixins/image_mixin"

export default {
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
